import { Container } from 'reactstrap';
import cls from 'classnames';
import { capitalize } from 'lodash-es';

export const Section = ({
    children,
    color = 'light',
    JumbotronProps = {},
    ...restProps
}) => (
    <section
        {...JumbotronProps}
        className={cls('jumbotron', `color${capitalize(color)}`, JumbotronProps?.className ?? '')}
    >
        <Container
            size="md"
            {...restProps}
        >
            {children}
        </Container>
    </section>
);
